import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { tomoIncludes, tomos } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/werbiFwLEiuaMUELe1gRkF/MOCKUP_-_Calistenia_0_limites.png';
export function TomosSection() {
  return <section id="tomos" className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="tomos-title" data-id="element-251" data-mp="1u1vi3dgel9re">
      <div className="mx-auto max-w-6xl" data-id="element-252" data-mp="11dpsodeemwl8">
        <div className="grid items-center gap-10 rounded-[2rem] border border-gold/25 bg-surface p-6 sm:p-10 lg:grid-cols-2" data-id="element-253" data-mp="11er62oiw7v64">
          <div className="text-center lg:text-left" data-id="element-254" data-mp="16f5guebvpj7u">
            <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-255" data-mp="1bcfak66awh1h">
              🏋️ Megakit de Ingeniería Corporal
            </p>
            <h2 id="tomos-title" className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl" data-id="element-256" data-mp="2hulnf3tswusp">
              Calistenia Cero Límites™
            </h2>
            <p className="mt-4 text-lg font-bold text-gold" data-id="element-257" data-mp="2mmwube5tp7ag">
              6 Tomos + 6 Bonos — Principiante → Élite
            </p>
            <p className="mt-2 text-sm text-neutral-400" data-id="element-258" data-mp="2hm91qo1y4ie4">
              300+ páginas — Todo resuelto.
            </p>
            <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-259" data-mp="2co7ju6g9ap48">
              {tomos.map(tomo => <li key={tomo.id} className="rounded-full border border-line bg-ink px-3.5 py-1.5 text-xs font-bold text-neutral-400" data-id="element-260" data-mp="27r7b1ns0v89f">
                  {tomo.label}
                </li>)}
            </ul>
          </div>
          <img src={MOCKUP_URL} alt="Contenido completo del Megakit Calistenia Cero Límites" className="mx-auto w-full max-w-md drop-shadow-[0_25px_50px_rgba(46,155,255,0.22)]" width={1024} height={1024} loading="lazy" data-id="element-261" data-mp="1tvvagzr6qnkl" />
        </div>

        <div className="mt-16" data-id="element-262" data-mp="1fb9bibvpplx6">
          <SectionHeading eyebrow="📚 6 Tomos completos" title="Principiante → Élite" data-id="element-263" data-mp="1fbiz5stabgzp" />
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-264" data-mp="11dawr5dhbnh5">
          {tomos.map((tomo, index) => <motion.li key={tomo.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group relative overflow-hidden rounded-2xl border border-line bg-surface p-6 transition-colors duration-200 hover:border-gold/50" data-id="element-265" data-mp="15ewhfcw9961w" data-mpi={index}>
              <span className="absolute right-4 top-1 text-6xl font-extrabold text-white/[0.05] transition-colors group-hover:text-gold/15" aria-hidden="true" data-id="element-266" data-mp="2c19utvdbba73">
                {tomo.id}
              </span>
              <p className="relative text-xs font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-267" data-mp="5b6i8uhp9i6e">
                {tomo.label}
              </p>
              <h3 className="relative mt-2 text-xl font-extrabold leading-tight tracking-tight text-white sm:text-2xl" data-id="element-268" data-mp="f3cbs8nlo7np">
                {tomo.title}
              </h3>
              <p className="relative mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-269" data-mp="3ijt6m62sqi3r">
                {tomo.description}
              </p>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-line bg-surface p-6 sm:p-8" data-id="element-270" data-mp="3dn2prgj63iha">
          <h3 className="text-lg font-extrabold tracking-tight text-white" data-id="element-271" data-mp="3sja625rgfzra">
            Cada tomo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-272" data-mp="17rq8ml2ycxxo">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-273" data-mp="12sndptgos83f">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-274" data-mp="12sdo46zk02y9" />
                <span className="text-sm text-neutral-300" data-id="element-275" data-mp="3dfr129b3u37h">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}